export default __webpack_public_path__ + "static/media/hallway-mid.763a3906.jpg";